import React, { useEffect, useRef, useState } from "react";
import LeftIcon from "../../images/LeftIcon";
import DatePicker from "react-datepicker";
import {
  reloadHeader,
  webLoadingFalse,
  webLoadingTrue,
  webNavigate,
} from "../../services/navigate.service";
import { createSales } from "../../services/sales.service";
import {
  validateEmail,
  validateNoSpecialChars,
  validateNoSpecialCharsOrSpaces,
  validateOnlyNumbers,
  validateOnlyNumbersNotThree,
  validatePhoneNumber,
} from "../../validation/ValidationInput";
import PopupLocation from "../../components/PopupLocation";
import BackIcon from "../../images/BackIcon";
import UploadIconV2 from "../../images/UploadIconV2";
import {
  createLanguage,
  createTranslation,
  loadDetailLanguage,
  loadDetailTranslation,
  loadListKey,
  updatdeLanguage,
  updatdeTranslation,
} from "../../services/language.services";
import { showToast } from "../../services/toast.service";
import { showApiError } from "../../services/apiError";
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from "../../services/fieldLimits";
import FieldCounter from "../../components/FieldCounter";
import UploadIcon from "../../images/UploadIcon";
import PhotoIcon from "../../images/PhotoIcon";
import { DropdownSearch } from "../../components/DropdownSearch";
import { useResponsive } from "../../hook/useResponsive";
interface InforTable {
  title: string;
  path: string;
  desc: string;
  titleCreate: string;
}

interface Country {
  id: string;
  code: string;
  name: string;
}

const CreateTranslation = () => {
  const [languageSearch, setLanguageSearch] = useState("");
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const preLanguage = localStorage.getItem("language");
  const [formValues, setFormValues] = useState<any>({});
  const [listKey, setListKey] = useState<any>([]);
  const dropdownLanguageref = useRef<HTMLDivElement>(null);
  const userId: string = localStorage.getItem("userId") || "";
  const [listLanguages, setListLanguages] = useState<any>([]);
  const [keyTranslation, setKeyTranslation] = useState("");
  const dropdownKeyref = useRef<HTMLDivElement>(null);
  const [language, setLanguage] = useState<any>(null);
  const [errors, setErrors] = useState<any>({});
  const limits = useFieldLimits(coreFormLimits("translation"));
  const { isMobile, getWidth } = useResponsive();
  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 50,
    sort: "DESC",
  });
  const [isKeyTranslationDropdownOpen, setIsKeyTranslationDropdownOpen] =
    useState(false);
  const path = window.location.pathname;
  const id: string = path.split("/").pop() || "";
  useEffect(() => {
    if (id !== "new") {
      fetchData(id);
    }
    const handleNewToken = () => {
      if (id !== "new") {
        fetchData(id);
      }
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, [path]);
  useEffect(() => {
    getListKey();
    const handleNewToken = () => {
      getListKey();
    };
    document.addEventListener("newToken", handleNewToken);
    return () => {
      document.removeEventListener("newToken", handleNewToken);
    };
  }, []);
  const getListKey = async () => {
    const response: any = await loadListKey();
    const keyArray = response?.data?.map((each: any) => each.key) || [];
    const languageArray =
      response?.data
        ?.map((each: any) => each.language)
        .filter(
          (value: any, index: any, self: any) =>
            self.findIndex((lang: any) => lang.name === value.name) === index,
        ) || [];
    setListLanguages(languageArray);
    setListKey(keyArray);
  };
  const fetchData = async (id: string) => {
    webLoadingTrue();
    try {
      const response: any = await loadDetailTranslation(id);
      setFormValues({
        languageId: response.data?.languageId,
        key: response.data?.key?.key,
        value: response.data?.value,
        userId: userId
      });
      setKeyTranslation(response.data?.key?.key);
      setLanguageSearch(response.data?.language?.name);
    } catch (error) {
      console.error("Error loading terms:", error);
    } finally {
      webLoadingFalse();
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownKeyref.current &&
        !dropdownKeyref.current.contains(event.target as Node)
      ) {
        setIsKeyTranslationDropdownOpen(false);
      }
      if (
        dropdownLanguageref.current &&
        !dropdownLanguageref.current.contains(event.target as Node)
      ) {
        setIsLanguageDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.addEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  const handleSubmit = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits(formValues, limits, language, ["languageId", "key", "value"]);
    if (!formValues.key) {
      newErrors.key = "Key is required";
    }
    if (!formValues.languageId) {
      newErrors.languageId = "Language is required";
    }
    if (!formValues.value) {
      newErrors.value = "Translation is required";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    webLoadingTrue();
    try {
      const payload: any = {
        languageId: formValues?.languageId,
        key: formValues?.key,
        value: formValues?.value,
        userId: userId
      };
      if (id !== "new") {
        const response: any = await updatdeTranslation(id, {
          languageId: formValues?.languageId,
          key: formValues?.key,
          value: formValues?.value,
          userId: userId
        });
        showToast({
          message: "Translation Updated Successfully!",
          type: "success",
          duration: 20000,
        });
      } else {
        const response: any = await createTranslation(payload);
        showToast({
          message: "Translation Created Successfully!",
          type: "success",
          duration: 20000,
        });
      }
      webLoadingFalse();
      webNavigate("/" + preLanguage + "/languages" + "?tab=Translations");
    } catch (error: any) {
      webNavigate("/" + preLanguage + "/languages" + "?tab=Translations");
      webLoadingFalse();
      showApiError(error, { language, setFieldErrors: setErrors });
    }
  };

  const handleKeySelect = (keyName: string) => {
    setFormValues((prev: any) => ({ ...prev, key: keyName }));
    setKeyTranslation(keyName);
    setIsKeyTranslationDropdownOpen(false);
  };

  const handleLanguageSelect = (laguage: any) => {
    setFormValues((prev: any) => ({ ...prev, languageId: laguage.id }));
    setLanguageSearch(laguage.name);
    setIsLanguageDropdownOpen(false);
  };

  return (
    <>
      <div className="bg-white">
        <div className="flex items-center ">
          <div
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate(
                "/" + preLanguage + "/languages" + "?tab=Translations",
              );
            }}
          >
            <BackIcon />
          </div>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "28px",
              color: "#222525",
            }}
            className="font-inter"
          >
            {language && language?.["Back"] ? language?.["Back"] : "Back"}
          </p>
        </div>
      </div>
      {id === "new" ? (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.[`Add translation`]
            ? language?.[`Add translation`]
            : `Add translation`}
        </p>
      ) : (
        <p
          style={{
            margin: "20px 0px",
            fontSize: "20px",
            fontWeight: "500",
            lineHeight: "28px",
            color: "#222525",
          }}
          className="font-inter"
        >
          {language && language?.[`Edit translation`]
            ? language?.[`Edit translation`]
            : `Edit translation`}
        </p>
      )}
      {/* <div className="flex items-center" style={{ marginTop: "24px", borderBottom: "1px solid #DEDEE2" }}>
                <p className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer" onClick={() => { setTab("profile") }}
                    style={tab === "profile" ? { marginRight: "24px", color: "#078D91", borderBottom: "1px solid #078D91" } : { marginRight: "24px", color: "#767685", borderBottom: "1px solid transparent" }} >Profile</p>
                <p className="text-[14px] font-inter leading-[21px] font-medium cursor-pointer" onClick={() => { setTab("invoices") }}
                    style={tab === "invoices" ? { color: "#078D91", borderBottom: "1px solid #078D91" } : { color: "#767685", borderBottom: "1px solid transparent" }} >Invoices</p>
            </div> */}
      <div style={{ height: "calc(100% - 163px)" }}>
        <>
          <form>
            <div
              className="flex items-center"
              style={{ gap: "24px", flexWrap: "wrap" }}
            >
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Key"] ? language?.["Key"] : "Key"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E14" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="key"
                    refs={{ key: dropdownKeyref }}
                    openStates={{ key: isKeyTranslationDropdownOpen }}
                    open={(key) =>
                      key === "key" && setIsKeyTranslationDropdownOpen(true)
                    }
                    close={(key) =>
                      key === "key" && setIsKeyTranslationDropdownOpen(false)
                    }
                    data={listKey}
                    labelExtractor={(item: any) => item.key}
                    value={keyTranslation}
                    setValue={setKeyTranslation}
                    onSelect={(item: any) => {
                      handleKeySelect(item.key);
                    }}
                    error={errors.key}
                    tabIndex={1}
                    borderNone={false}
                  />
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Language"]
                      ? language?.["Language"]
                      : "Language"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E14" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <DropdownSearch
                    refKey="language"
                    refs={{ language: dropdownLanguageref }}
                    openStates={{ language: isLanguageDropdownOpen }}
                    open={(language) =>
                      language === "language" && setIsLanguageDropdownOpen(true)
                    }
                    close={(language) =>
                      language === "language" &&
                      setIsLanguageDropdownOpen(false)
                    }
                    data={listLanguages}
                    labelExtractor={(item: any) => item.name}
                    value={languageSearch}
                    setValue={setLanguageSearch}
                    error={errors.languageId}
                    onSelect={(item: any) => {
                      handleLanguageSelect(item);
                    }}
                    tabIndex={2}
                    borderNone={false}
                  />
                </div>
              </div>
              <div
                className="space-y-2"
                style={{ width: isMobile ? "100%" : "calc(33% - 12px)" }}
              >
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#4A5353" }}
                  >
                    {language && language?.["Translation"]
                      ? language?.["Translation"]
                      : "Translation"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px]"
                    style={{ color: "#BA0E14" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={3}
                    value={formValues?.value}
                    onKeyDown={validateNoSpecialChars}
                    name="value"
                    {...limitProps(limits, "value")}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues?.value} max={limits.value?.maxLength} />
                </div>
                {errors.value && <p className="error">{errors.value}</p>}
              </div>
            </div>
          </form>
        </>
      </div>
      <div
        className="w-full flex items-center justify-end"
        style={{ marginTop: "24px", gap: "12px" }}
      >
        <div
          onClick={() => {
            webNavigate("/" + preLanguage + "/languages" + "?tab=Translations");
          }}
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#222525",
            fontSize: "14px",
            fontWeight: "500",
            border: "1px solid #C9D7D8",
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.["Cancel"] ? language?.["Cancel"] : "Cancel"}
        </div>
        <div
          style={{
            padding: "10px 24px",
            borderRadius: "30px",
            color: "#FFFFFF",
            fontSize: "14px",
            fontWeight: "500",
            backgroundColor: "#0F7679",
          }}
          className="font-inter cursor-pointer"
          onClick={(e: any) => {
            handleSubmit(e);
          }}
        >
          <p className="text-[14px] leading-[22px] font-inter">
            {language && language?.["Save"] ? language?.["Save"] : "Save"}
          </p>
        </div>
      </div>
    </>
  );
};
export default CreateTranslation;
